import { useEffect, useState } from 'react'

/** Атрибут шапки адмінки (DefaultLayout): під нею прилипає шапка таблиці */
const LAYOUT_HEADER_SELECTOR = '[data-layout-header]'

/** Висота шапки адмінки, якщо її не вдалося виміряти (десктоп, див. DefaultLayout.module.css) */
const DEFAULT_LAYOUT_HEADER_HEIGHT = 64

const measureLayoutHeader = (): number => {
    if (typeof document === 'undefined') return DEFAULT_LAYOUT_HEADER_HEIGHT
    const header = document.querySelector(LAYOUT_HEADER_SELECTOR)
    return header ? Math.round(header.getBoundingClientRect().height) : DEFAULT_LAYOUT_HEADER_HEIGHT
}

/**
 * Поточна висота липкої шапки адмінки (64 на десктопі, 56 на телефоні); оновлюється при
 * resize. Для `sticky.offsetHeader` таблиць (списки колекцій, звіти).
 */
export const useLayoutHeaderHeight = (): number => {
    const [height, setHeight] = useState(measureLayoutHeader)

    useEffect(() => {
        const update = () => setHeight(measureLayoutHeader())
        update()
        window.addEventListener('resize', update)
        return () => window.removeEventListener('resize', update)
    }, [])

    return height
}
